angular.module("dx.webapp.logging", [
	"ngRaven",
	"ngCookies",
]);
